import { CopyIcon, EditIcon } from "@chakra-ui/icons";
import { Box, Button, Icon, Text } from "@chakra-ui/react";
import React from "react";
import { useNavigate } from "react-router-dom";
import useCloneReadingOrder from "../hooks/useCloneReadingOrder";

const SuggestCorrection = ({ readingOrderId }) => {
  const navigate = useNavigate();
  const { isCloning, onClickClone } = useCloneReadingOrder(readingOrderId);
  return (
    <Box bg="gray.900" p="6" borderRadius="lg" mt="2">
      <Text pb="2" textColor="gray.500" fontSize="sm">
        Something is not quite right with the order?
      </Text>
      <Button
        leftIcon={<Icon as={EditIcon} />}
        variant="outline"
        size="sm"
        textColor="gray.200"
        onClick={() => {
          navigate(`/reading-orders/${readingOrderId}/suggest-correction`);
        }}
      >
        Suggest a correction
      </Button>

      <Text py="2" pt="6" textColor="gray.500" fontSize="sm">
        Wanna copy this reading order and make your own version?
      </Text>
      <Button
        leftIcon={<Icon as={CopyIcon} />}
        variant="outline"
        size="sm"
        textColor="gray.200"
        disabled={isCloning}
        onClick={() => onClickClone(readingOrderId)}
      >
        Clone reading order
      </Button>
    </Box>
  );
};

export default SuggestCorrection;
